import React from 'react'
import PropTypes from 'prop-types'
import { Box, useStyleConfig } from '@chakra-ui/react'

function CardBody(props) {
  const { variant, children, ...rest } = props
  const styles = useStyleConfig('CardBody', { variant })

  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  )
}

CardBody.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
}

export default CardBody
